import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'sibat-base-button',
  template: `
    <button
      mat-button
      class="button"
      [type]="submit ? 'submit' : 'button'"
      [class.button-disabled]="disabled"
      [class.button-stretch]="stretch"
      [disabled]="disabled"
      (click)="clicked.emit($event)"
    >
      @if (icon) {
      <mat-icon>{{ icon }}</mat-icon>
      }
      <span>{{ label }}</span>
    </button>
  `,
  styleUrls: ['buttons.scss'],
  host: { class: 'sibat-base-button' },
  imports: [MatButton, MatIcon],
})
export class BaseButtonComponent {
  @Input() label: string;
  @Input() icon?: string;
  @Input() disabled = false;
  @Input() stretch = false;
  @Input() submit = false;
  @Output() clicked = new EventEmitter();

  constructor() {}
}
